module.exports = __webpack_public_path__ + "static/village_slide_img03-82691c89b63d15d6682d0dc070c9b77e.png";